import { convertToUserTime } from "./dateUtils/convertToUserTime";
import { expiryInfo, phaseToClass } from "./expiryUtils";
export type CompetencyStatus = 'active' | 'expiring' | 'expired';

// Returns competency status label mapping (e.g. active → "Valid").
export const competencyStatusLabel: Record<CompetencyStatus, string> = { active: 'Valid', expiring: 'Expiring', expired: 'Expired' };

export const COMPETENCY_LEAD_DAYS = 30;

// Evaluates overall competency status based on expiry date and optional isExpired flag.
// Rules:
// - If isExpired is true or dToExpiry < 0 → 'expired'
// - If dToExpiry is within COMPETENCY_LEAD_DAYS (default 30) → 'expiring'
// - Otherwise → 'active'
export function getCompetencyStatus(row: { competencyExpiryDate?: Date | string | null; isExpired?: boolean }): CompetencyStatus {
    const ei = expiryInfo(COMPETENCY_LEAD_DAYS, row.competencyExpiryDate);
    if (row.isExpired || (typeof ei.dToExpiry === 'number' && ei.dToExpiry < 0)) return 'expired';
    if (typeof ei.dToExpiry === 'number' && ei.dToExpiry < COMPETENCY_LEAD_DAYS) return 'expiring';
    return 'active';
}

// Returns display-ready expiry information for competency.
// Includes:
// - formatted date text (using convertToUserTime)
// - daysToExpiry count (positive = remaining, negative = overdue)
// - Tailwind className based on phase (ok | warn | error)
// - display string including "±X days"
// If no expiry is provided → returns fallback { n/a, text-slate-700 }
export function getCompetencyExpiryInfo(expiry?: Date | string | null) {
    const ei = expiryInfo(COMPETENCY_LEAD_DAYS, expiry);
    if (!expiry) return { dateText: 'n/a', className: 'text-slate-700', display: 'n/a' };
    const dateText = convertToUserTime(new Date(expiry as any).toISOString(), true);
    const cls = phaseToClass[ei.phase];
    if (typeof ei.dToExpiry !== 'number') return { dateText, className: cls, display: dateText };
    const abs = Math.abs(ei.dToExpiry);
    const sign = ei.dToExpiry >= 0 ? '' : '-';
    return { dateText, daysToExpiry: ei.dToExpiry, className: cls, display: `${dateText} (${sign}${abs} days)` };
}
